"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPENING_SESSION_STACK_VAR = void 0;
exports.encodeOpeningSessionFrame = encodeOpeningSessionFrame;
exports.parseOpeningSessionFrame = parseOpeningSessionFrame;
/** Player stack variable name (must match `VariablesConfig.md` / backend). */
exports.OPENING_SESSION_STACK_VAR = 'opening_session_id';
const FRAME_SEP = '|';
const RETURN_SCENE_MARKER = '@return:';
function encodeOpeningSessionFrame(parts) {
    const { sessionId, playerSlot, triggeringAdventureId, returnSceneId } = parts;
    const base = `${sessionId}${FRAME_SEP}${playerSlot}${FRAME_SEP}${triggeringAdventureId}`;
    const normalizedReturnSceneId = (returnSceneId ?? '').trim();
    if (!normalizedReturnSceneId) {
        return base;
    }
    return `${base}${FRAME_SEP}${RETURN_SCENE_MARKER}${normalizedReturnSceneId}`;
}
/**
 * Parse an encoded opening-session frame:
 * - sessionId|playerSlot|triggeringAdventureId
 * - sessionId|playerSlot|triggeringAdventureId|@return:returnSceneId
 * Player slot may contain `|`; adventure id is the final segment for legacy frames,
 * or the second-to-last segment when returnSceneId marker is present.
 */
function parseOpeningSessionFrame(frame) {
    if (!frame || typeof frame !== 'string')
        return null;
    const parts = frame.split(FRAME_SEP);
    if (parts.length < 3)
        return null;
    const sessionId = parts[0]?.trim() ?? '';
    const lastSegment = parts[parts.length - 1]?.trim() ?? '';
    const hasReturnSceneId = lastSegment.startsWith(RETURN_SCENE_MARKER);
    const triggeringAdventureIndex = hasReturnSceneId ? parts.length - 2 : parts.length - 1;
    const playerSlotEnd = hasReturnSceneId ? parts.length - 2 : parts.length - 1;
    const triggeringAdventureId = parts[triggeringAdventureIndex]?.trim() ?? '';
    const playerSlot = parts.slice(1, playerSlotEnd).join(FRAME_SEP).trim();
    const returnSceneId = hasReturnSceneId ? lastSegment.substring(RETURN_SCENE_MARKER.length).trim() : '';
    if (!sessionId || !playerSlot || !triggeringAdventureId)
        return null;
    return { sessionId, playerSlot, triggeringAdventureId, returnSceneId: returnSceneId || undefined };
}
//# sourceMappingURL=openingSessionStack.js.map